/* eslint-disable no-unused-vars */
// needed since color isn't used in the template but appears in the replaced body
import React from "react";
import PropTypes from "prop-types";

/*
 * Yuka v2.0
 * This component corresponds to ``notification-msg.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */
const NotificationMsgIcon = ({ color, size }) => (
  <svg width={size} height={size} viewBox="0 0 18 18">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        fill={color}
        fillRule="evenodd"
        d="M14.5607 3.43934C13.9749 2.85355 13.0251 2.85355 12.4393 3.43934C11.8536 4.02513 11.8536 4.97487 12.4393 5.56066C13.0251 6.14645 13.9749 6.14645 14.5607 5.56066C15.1464 4.97487 15.1464 4.02513 14.5607 3.43934ZM11.3787 2.37868C12.5503 1.20711 14.4497 1.20711 15.6213 2.37868C16.7929 3.55025 16.7929 5.44975 15.6213 6.62132C14.4497 7.79289 12.5503 7.79289 11.3787 6.62132C10.2071 5.44975 10.2071 3.55025 11.3787 2.37868ZM5.81903 2.25H8.25C8.66421 2.25 9 2.58579 9 3C9 3.41421 8.66421 3.75 8.25 3.75H5.85C5.20757 3.75 4.77085 3.75058 4.43328 3.77816C4.10447 3.80503 3.93631 3.85372 3.81902 3.91349C3.53677 4.0573 3.3073 4.28677 3.16349 4.56901C3.10372 4.68631 3.05503 4.85447 3.02816 5.18328C3.00058 5.52085 3 5.95756 3 6.6V12.15C3 12.7924 3.00058 13.2292 3.02816 13.5667C3.05503 13.8955 3.10372 14.0637 3.16349 14.181C3.3073 14.4632 3.53677 14.6927 3.81902 14.8365C3.93631 14.8963 4.10447 14.945 4.43328 14.9718C4.77085 14.9994 5.20757 15 5.85 15H11.4C12.0424 15 12.4792 14.9994 12.8167 14.9718C13.1455 14.945 13.3137 14.8963 13.431 14.8365C13.7132 14.6927 13.9427 14.4632 14.0865 14.181C14.1463 14.0637 14.195 13.8955 14.2218 13.5667C14.2494 13.2292 14.25 12.7924 14.25 12.15V9.75C14.25 9.33579 14.5858 9 15 9C15.4142 9 15.75 9.33579 15.75 9.75V12.181C15.75 12.7847 15.75 13.283 15.7169 13.6889C15.6824 14.1104 15.6085 14.498 15.423 14.862C15.1354 15.4265 14.6765 15.8854 14.112 16.173C13.748 16.3585 13.3604 16.4324 12.9389 16.4669C12.533 16.5 12.0347 16.5 11.431 16.5H5.81901C5.21529 16.5 4.71702 16.5 4.31113 16.4669C3.88956 16.4324 3.50203 16.3585 3.13803 16.173C2.57354 15.8854 2.1146 15.4265 1.82698 14.862C1.64151 14.498 1.56759 14.1104 1.53315 13.6889C1.49998 13.283 1.49999 12.7847 1.5 12.181V6.56903C1.49999 5.9653 1.49998 5.46703 1.53315 5.06113C1.56759 4.63956 1.64151 4.25203 1.82698 3.88803C2.1146 3.32354 2.57354 2.8646 3.13803 2.57698C3.50203 2.39151 3.88956 2.31759 4.31113 2.28315C4.71703 2.24998 5.2153 2.24999 5.81903 2.25ZM4.5 9.75C4.5 9.33579 4.83579 9 5.25 9H11.25C11.6642 9 12 9.33579 12 9.75C12 10.1642 11.6642 10.5 11.25 10.5H5.25C4.83579 10.5 4.5 10.1642 4.5 9.75ZM4.5 12.75C4.5 12.3358 4.83579 12 5.25 12H9.75C10.1642 12 10.5 12.3358 10.5 12.75C10.5 13.1642 10.1642 13.5 9.75 13.5H5.25C4.83579 13.5 4.5 13.1642 4.5 12.75Z"
        transform=""
      />
    </g>
  </svg>
);

NotificationMsgIcon.propTypes = {
  // all of these can be overriden in CSS as necessary
  color: PropTypes.string,
  size: PropTypes.number,
};

NotificationMsgIcon.defaultProps = {
  color: "#ffffff",
  size: 16,
};

NotificationMsgIcon.displayName = "NotificationMsgIcon";

export default NotificationMsgIcon;
